"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var sortColumns = function (columns, collumnsSetting) {
    if (!collumnsSetting || !Object.keys(collumnsSetting).length)
        return columns;
    var leftColumns = [];
    var centerColumns = [];
    var rightColumns = [];
    var columnsSettingKeys = collumnsSetting
        .reduce(function (acc, item, index) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.key] = index, _a)));
    }, {});
    columns.forEach(function (column) {
        var id = column.id, _a = column.staticLeftCol, staticLeftCol = _a === void 0 ? false : _a, _b = column.staticRightCol, staticRightCol = _b === void 0 ? false : _b;
        if (staticLeftCol) {
            leftColumns.push(column);
            return;
        }
        if (staticRightCol) {
            rightColumns.push(column);
            return;
        }
        centerColumns[columnsSettingKeys[id]] = column;
    });
    return __spreadArray(__spreadArray(__spreadArray([], leftColumns, true), centerColumns.filter(function (item) { return !!item; }), true), rightColumns, true);
};
exports.default = sortColumns;
